/**
 * Documentation KFP API
 * ## Common Request Headers - Authorization (string `Bearer {AccessToken}`, if signed-in) - After the client has successfully obtained `AccessToken` via Login, it\'s sent in every request as a bearer token.
 *
 * The version of the OpenAPI document: 1
 * Contact: novak@techcrowd.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetUsersFilterParameter { 
  [key: string]: any | any;


    email?: string;
    firstname?: string;
    lastname?: string;
    phone?: string;
    address_city?: string;
    address_street?: string;
    address_country?: string;
    login_count?: number;
    calculation_count?: number;
    last_login?: string;
    company_name?: string;
}

